const COLOR = [
  "text-primary-40",
  "text-custom-dark-orange",
  "text-custom-dark-violet",
  "text-custom-dark-green",
  "text-custom-dark-blue",
  "text-custom-pink",
  "text-custom-yellow",
  "text-custom-red",
  "text-custom-gray",
  "text-custom-brown",
];

const BACKGROUND_COLOR = [
  "bg-primary-95",
  "bg-custom-light-orange",
  "bg-custom-light-violet",
  "bg-custom-light-green",
  "bg-custom-light-blue",
  "bg-custom-light-pink",
  "bg-custom-light-yellow",
  "bg-custom-light-red",
  "bg-custom-light-gray",
  "bg-custom-light-brown",
];

export const shortenText = (name: string): string => {
  const words = name.split(" ");

  if (words.length === 1) {
    return words[0]?.slice(0, 2).toLocaleUpperCase() || "";
  }

  if (words.length >= 2) {
    return `${words[0] && words[0][0]}${words[1] && words[1][0]}`.toLocaleUpperCase();
  }

  return "";
};

const random = (text: string, factor: number) => ((text.codePointAt(0) ?? 0) + (text.codePointAt(1) ?? 0)) % factor;

export const getBackgroundColor = (text: string): string =>
  BACKGROUND_COLOR[random(text, BACKGROUND_COLOR.length)] || "bg-primary-95";

export const getColor = (text: string): string => COLOR[random(text, COLOR.length)] || "text-primary-40";

/**
 * Loose on purpose, and deliberately unanchored: it has to accept the `blob:http://…` object URLs the
 * profile screens hand to `Avatar.Image` for a local file preview, not just plain `https://` links.
 * What it rejects is the case that actually costs something: a bare id, or any other non-URL string.
 * The browser resolves one of those against the current path, so an `<img src="<id>">` rendered on
 * `/terminal/lineup/<id>` fetches `/terminal/lineup/<id>` as a document and the server renders the
 * whole guarded page a second time, for a result nothing reads.
 *
 * This used to carry a long tail of optional host/port/path groups. Every one of them sat behind an
 * already-unbounded `\S+`, so none of them could change the outcome of a `test()` — the pattern below
 * accepts and rejects exactly the same strings, and is what the old one always meant.
 */
const URL_PATTERN = /https?:\/\/\S/;

export const isImageUrl = (src: string): boolean => URL_PATTERN.test(src);
